import React, { useContext, useState } from "react";
import { firebase } from "../constants/firebase";
import { PopupContext } from "../containers/Popup";
import { UserContext } from "../containers/UserProvider";
import { RadioSelect } from "./RadioSelect";

const options = [
  {
    name: "Hate Speech",
    value: "Hate Speech",
  },
  {
    name: "Threatening",
    value: "Threatening",
  },
  {
    name: "Pornographic",
    value: "Pornographic",
  },
  {
    name: "Spam",
    value: "Spam",
  },
  {
    name: "Harassment",
    value: "Harassment",
  },
  {
    name: "Other",
    value: "Other",
  },
];

export const ReportPage = ({ closeModal }) => {
  const [reasons, setReasons] = useState([]);
  const [error, setError] = useState("");
  const [otherText, setOtherText] = useState("");
  const db = firebase.firestore();
  const user = useContext(UserContext);
  const {
    showModal: { detail },
  } = useContext(PopupContext);

  const commentId = detail?.commentId;
  const replyId = detail?.replyId;

  const isOtherSelected = reasons.includes("Other");

  const onSubmit = (e) => {
    e.preventDefault();

    if (!reasons.length) {
      setError("Please select at least one option.");
      return;
    }

    if (isOtherSelected && !otherText) {
      setError("Please enter a short sentence describing the report.");
      return;
    }

    setError("");

    const now = firebase.firestore.Timestamp.fromDate(new Date());

    const issues = otherText ? [...reasons, otherText] : reasons;

    db.collection("reports")
      .where("reporter", "==", db.doc(`/users/${user.uid}`))
      .get()
      .then((snapshot) => {
        if (snapshot.docs.length) {
          snapshot.docs[0].ref
            .update({
              reasons: issues,
              updatedAt: now,
            })
            .then(() => {
              closeModal();
            });
        } else {
          const report = {
            createdAt: now,
            updatedAt: now,
            comment: db.doc(`/comments/${commentId}`),
            reasons: issues,
            reporter: db.doc(`/users/${user.uid}`),
          };

          if (replyId) {
            report.reply = db.doc(`/replies/${replyId}`);
          }

          db.collection("reports")
            .add(report)
            .then(() => {
              closeModal();
            });
        }
      });
  };

  return (
    <div className="w-full text-white">
      <div>
        <p className="text-red-500">{error}</p>
        <form onSubmit={onSubmit}>
          <RadioSelect
            label="Report this comment"
            options={options}
            values={reasons}
            setValue={setReasons}
            isMulti
          />
          {isOtherSelected && (
            <input
              type="text"
              className="shadow appearance-none border mt-3 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
              placeholder="Reason"
            />
          )}
          <button
            type="submit"
            className="hover:bg-blue-800 bg-blue-700 py-3 my-4 px-8 w-full focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg "
          >
            Submit Report
          </button>
        </form>
      </div>
    </div>
  );
};
